import React from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { assign, orderBy } from 'lodash';
import { filterRescuesListInfiniteScroll, getScheduleAvailableRescues } from '../../../../../helpers/RescuesHelper';
import RescuerScheduleFiltersDialog from '../../../../../components/RescuersScheduleFilters/RescuerScheduleFiltersDialog';
import useActiveUser from '../../../../../hooks/useActiveUser';
import useUIFilter from '../../../../../hooks/useUIFilter';
import { initialRescuerScheduleFilters } from '../../../../../reducers/ui';
import { RESCUER_SCHEDULE_FILTER } from '../../Schedule/ScheduleMobile';

const RescuerScheduleApplyFilters = () => {
  const activeUser = useActiveUser();
  const rescuesEntities = useSelector((state) => state.entities.rescues);
  const { getUIFilter } = useUIFilter();
  const scheduleFilters = assign(initialRescuerScheduleFilters, getUIFilter(RESCUER_SCHEDULE_FILTER));
  const rescuerAvailableRescues = getScheduleAvailableRescues(activeUser.id, rescuesEntities);
  const rescuesById = rescuerAvailableRescues.data.map((rescueId) => rescuesEntities.byId[rescueId]);
  const filteredAvailableRescues = filterRescuesListInfiniteScroll(rescuesById, scheduleFilters);

  const availableFilteredRescuesSorted = orderBy(
    filteredAvailableRescues,
    (availableRescue) => moment(`${availableRescue.date} ${availableRescue.pickup_begin}`, 'YYYYMMDD HH:mm:ss'),
    ['asc']
  );

  return (
    <RescuerScheduleFiltersDialog
      availableRescues={rescuesById}
      filteredRows={availableFilteredRescuesSorted}
      isClaimRescueDashboard
    />
  );
};

export default RescuerScheduleApplyFilters;
